module.exports = __webpack_public_path__ + "static/media/khanda.0ee462dd.svg";